import { makeGraphQlCallWithoutShareTokens } from '../../data/util';
import { graphql } from '../../graphqlTypes/graphql';

const GuestUserQuery = graphql(`
  query GuestUserQuery($uid: String!) {
    User(uid: $uid) {
      firstName
      lastName
      email
      _id
    }
  }
`);

export const getGuestUserData = async (guestUserId: string, enabled?: boolean) => {
  const resp = await makeGraphQlCallWithoutShareTokens(GuestUserQuery, { uid: guestUserId as string });
  return resp?.User ?? {};
};
